import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-009d5d7c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "damage-reported-body-container" }
const _hoisted_2 = {
  key: 0,
  class: "damage-reported-body-wrapper"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Thank You for Reporting", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "description" }, " Issue reports keep our trailer fleet healthy. We apologize for the inconvenience. Please call your dispatcher if you need assistance. ", -1))
const _hoisted_5 = {
  key: 1,
  class: "damage-reported-body-wrapper"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Thank You for Reporting Damage", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "description" }, " Damage reports keep our trailer fleet healthy. We apologize for the inconvenience. Please call your dispatcher if you need assistance. ", -1))
const _hoisted_8 = { class: "return-option" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FbxButton = _resolveComponent("FbxButton")!
  const _component_ReturnOptions = _resolveComponent("ReturnOptions")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.showNonDamageIssue)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _hoisted_4,
          _createVNode(_component_FbxButton, {
            "button-text": "Find Another Trailer",
            theme: "primary",
            class: "portrait-text-color",
            onClick: _ctx.findAnotherTrailer
          }, null, 8, ["onClick"])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _hoisted_6,
          _hoisted_7,
          _createVNode(_component_FbxButton, {
            "button-text": "Find Another Trailer",
            theme: "primary",
            class: "portrait-text-color",
            onClick: _ctx.findAnotherTrailer
          }, null, 8, ["onClick"])
        ])),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_ReturnOptions)
    ])
  ]))
}